import { render, staticRenderFns } from "./CockpitBooleanComponent.vue?vue&type=template&id=314d373e&scoped=true"
import script from "./CockpitBooleanComponent.vue?vue&type=script&lang=js"
export * from "./CockpitBooleanComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314d373e",
  null
  
)

export default component.exports